import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import type { FollowUpConfigDraft } from 'services/types/followUpConfig';

import SurveyConfigForm from './SurveyConfigForm';

interface SurveyConfigurationSectionProps {
  followUpConfigDraft: FollowUpConfigDraft;
  isEditing: boolean;
  setFollowUpConfigDraft?: (followUpConfigDraft: FollowUpConfigDraft) => void;
  required?: boolean;
}

const SurveyConfigurationSection: FC<SurveyConfigurationSectionProps> = ({
  followUpConfigDraft,
  isEditing,
  setFollowUpConfigDraft,
  required = false,
}) => {
  if (!required && !isEditing && !followUpConfigDraft.surveyConfig) {
    return null;
  }

  return (
    <Card sx={{ mb: 1.5, boxShadow: 0, borderRadius: 0 }}>
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Typography variant="h6" gutterBottom sx={{ mb: 1.5, fontWeight: 600 }}>
          Configuración de Encuesta
        </Typography>
        <SurveyConfigForm
          surveyConfig={followUpConfigDraft.surveyConfig || null}
          onSurveyConfigChange={(surveyConfig) => {
            if (setFollowUpConfigDraft) {
              setFollowUpConfigDraft({
                ...followUpConfigDraft,
                surveyConfig,
              });
            }
          }}
          disabled={!isEditing}
          required={required}
        />
      </CardContent>
    </Card>
  );
};

export default SurveyConfigurationSection;
